var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},_vm._l((_vm.list),function(item){return _c('a',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(item.img),expression:"item.img",arg:"background-image"}],staticClass:"img",style:({backgroundColor: item.color}),attrs:{"href":item.link,"target":"_blank"}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-48de7190","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = Q5JW
// module chunks = 1